module.exports = __webpack_public_path__ + "img/disneyBackground.513e9419.png";